import React, { Component, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
export default function Header() {
  if (!sessionStorage.getItem("lang")) {
    sessionStorage.setItem("lang", "ar");
  }
  let { t, i18n } = useTranslation();
  const pathname = window.location.pathname;
  const [show, setShow] = useState(false);
  const [lang, setLang] = useState(sessionStorage.getItem("lang"));
  const [profile, setProfile] = useState({
    access_token: "",
    user: { email: "" },
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const showmenu = () => {
    setShow(!show);
  };
  const onChangeLang = (lg: string) => {
    // setLang(lg);
    sessionStorage.setItem("lang", lg);
    i18n.changeLanguage(lg);
    showmenu();
    //window.location.reload();
    if (lg === "en") {
      window.location.href =
        "https://www.hitachi-homeappliances.com/ae/eng/choose-your-refrigerator/";
    }
  };
  useEffect(() => {}, []);
  return (
    <header className="App-header">
      <div className="row align-items-center h-100 w-100 py-0">
        <div className="col-3 col-sm-2 col-md-2 text-start home-icon">
          <a href="https://www.hitachi-homeappliances.com/ae/ar/choose-your-refrigerator/">
            <img src="images/home_ic.png" />
          </a>
        </div>
        <div className="col-6 col-sm-8 col-md-8 text-center hitachi-logo">
          <img src="images/logo.png" />
        </div>
        <div className="col-3 col-sm-2 col-md-2">
          <div className="lang ms-auto">
            <button
              className="select-lang text-uppercase"
              onClick={() => showmenu()}
            >
              AR
            </button>
            <ul className={`ul-lang ${show ? "d-block" : ""}`}>
               <li onClick={() => onChangeLang("en")}>EN</li>
              {/*<li onClick={() => onChangeLang("th")}>TH</li> */}
              <li onClick={()=>onChangeLang("ar")}>AR</li>
              {/* <li onClick={()=>onChangeLang("ar")}>AR</li> */}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}
